import MonacoEditor from "@monaco-editor/react";
import Typewriter from "typewriter-effect";
import { useState, useEffect } from "react";

const CodeViewer = ({ code, language }) => {
  const [displayedCode, setDisplayedCode] = useState("");

  useEffect(() => {
    if (code) {
      let currentIndex = 0;
      const interval = setInterval(() => {
        if (currentIndex <= code.length) {
          setDisplayedCode(code.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(interval);
        }
      }, 20); // 30ms delay between characters

      return () => clearInterval(interval);
    }
  }, [code]);

  return (
    <div className="h-[90%]">
      <div className="h-full text-white">
        <MonacoEditor
          height="100%"
          language={language.toLowerCase()}
          theme="hc-black"
          value={displayedCode}
          options={{
            readOnly: true,
            minimap: { enabled: true },
            fontSize: 14,
            scrollBeyondLastLine: false,
            wordWrap: "on",
            lineNumbers: "on",
            renderLineHighlight: "none",
          }}
        />
      </div>
    </div>
  );
};

export default CodeViewer;
